var RN = require('react-native');

exports._alert = RN.Alert.alert;
